import Immutable from 'immutable';
import moment from 'moment';
import _ from 'underscore';

import ClassFactory from 'sharedreact/utils/ClassFactory';
import { translate } from 'sharedreact/utils/LanguageSupport';

const placeHolderString = 'placeholder-ordermaterial';
let orderMaterialCounter = 1;

const Content: {
  id: string,
  name: string,
  thickness: number,
  weight: number,
  description: string,
  creationDate: moment.Moment | null,
  modificationDate: moment.Moment | null
} = {
  id: '',
  name: '',
  thickness: 0,
  weight: 0,
  description: '',
  creationDate: null,
  modificationDate: null
};

class OrderMaterial extends Immutable.Record(Content) {
  static createTemp (): OrderMaterial {
    const name = translate('common.general.title.new') + ' ' + orderMaterialCounter;
    orderMaterialCounter++;

    return new OrderMaterial({
      id: _.uniqueId(placeHolderString),
      name: name
    });
  }

  static fromJS (json: object): OrderMaterial {
    return ClassFactory.createFromJson(json, OrderMaterial);
  }

  isNew (): boolean {
    // assume the order material comes from the server if it has a creation date
    return this.id.startsWith(placeHolderString);
  }

  get isValid (): boolean {
    return !!this.id && !!this.name && this.thickness >= 0 && this.weight >= 0;
  }
}

export default OrderMaterial;
